(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wy-featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Keep track of autoplay intervals globally to prevent duplicates on hot-reload
  window.wyFeaturedAutoplayIntervals = window.wyFeaturedAutoplayIntervals || {};

  function initFeatured(sectionEl) {
    const id = sectionEl.id.replace('wy-featured-', '');

    // Clear any existing autoplay interval for this section ID
    if (window.wyFeaturedAutoplayIntervals[id]) {
      clearInterval(window.wyFeaturedAutoplayIntervals[id]);
      delete window.wyFeaturedAutoplayIntervals[id];
    }

    // ── Tabs ──
    const tabs   = sectionEl.querySelectorAll('.wy-tab');
    const panels = sectionEl.querySelectorAll('.wy-featured__panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.dataset.tabId;
        tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected','true');
        panels.forEach(p => {
          p.classList.toggle('is-hidden', p.dataset.blockId !== targetId);
        });
        // reset scroll
        panels.forEach(p => { if (!p.classList.contains('is-hidden')) p.scrollLeft = 0; });
        updateArrows();
      });
    });

    // ── Carousel prev/next ──
    const prevBtn = sectionEl.querySelector('#wy-feat-prev-' + id);
    const nextBtn = sectionEl.querySelector('#wy-feat-next-' + id);

    function activeTrack() {
      return sectionEl.querySelector('.wy-featured__panel:not(.is-hidden)') ||
             sectionEl.querySelector('.wy-featured__panel');
    }

    function scroll(dir) {
      const track = activeTrack();
      if (!track) return;
      const item = track.querySelector('.wy-featured__item');
      const gap = parseFloat(window.getComputedStyle(track).gap) || 16;
      const step = item ? item.offsetWidth + gap : 280;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (prevBtn) {
      const newPrevBtn = prevBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
      newPrevBtn.addEventListener('click', () => scroll(-1));
    }
    if (nextBtn) {
      const newNextBtn = nextBtn.cloneNode(true);
      nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
      newNextBtn.addEventListener('click', () => scroll(1));
    }

    const finalPrevBtn = sectionEl.querySelector('#wy-feat-prev-' + id);
    const finalNextBtn = sectionEl.querySelector('#wy-feat-next-' + id);

    // ── Update arrow states ──
    function updateArrows() {
      const track = activeTrack();
      if (!track || !finalPrevBtn || !finalNextBtn) return;
      
      const isGrid = sectionEl.classList.contains('layout-desktop-grid') && window.innerWidth > 768 ||
                     sectionEl.classList.contains('layout-mobile-grid') && window.innerWidth <= 768;
                     
      if (isGrid) {
        finalPrevBtn.style.display = 'none';
        finalNextBtn.style.display = 'none';
        return;
      } else {
        finalPrevBtn.style.display = '';
        finalNextBtn.style.display = '';
      }

      const tolerance = 5;
      finalPrevBtn.disabled = track.scrollLeft < tolerance;
      finalNextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - tolerance;
    }

    panels.forEach(p => {
      p.addEventListener('scroll', updateArrows, { passive: true });
    });

    // ── Resize Observer for updating arrows dynamically ──
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        updateArrows();
      });
      panels.forEach(panel => {
        resizeObserver.observe(panel);
      });
    } else {
      window.addEventListener('resize', updateArrows);
    }
    
    updateArrows();

    // ── Autoplay ──
    const auto  = sectionEl.dataset.autoplay === 'true';
    const speed = parseInt(sectionEl.dataset.autoplaySpeed, 10) || 4000;
    if (auto) {
      let isHovered = false;

      const intervalId = setInterval(() => {
        if (isHovered) return;
        const track = activeTrack();
        if (!track) return;
        
        const isGrid = sectionEl.classList.contains('layout-desktop-grid') && window.innerWidth > 768 ||
                       sectionEl.classList.contains('layout-mobile-grid') && window.innerWidth <= 768;
        if (isGrid) return;

        const item = track.querySelector('.wy-featured__item');
        const gap = parseFloat(window.getComputedStyle(track).gap) || 16;
        const step = item ? item.offsetWidth + gap : 280;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
        track.scrollBy({ left: atEnd ? -track.scrollWidth : step, behavior: 'smooth' });
      }, speed);

      window.wyFeaturedAutoplayIntervals[id] = intervalId;

      sectionEl.addEventListener('mouseenter', () => { isHovered = true; });
      sectionEl.addEventListener('mouseleave', () => { isHovered = false; });
      sectionEl.addEventListener('touchstart', () => { isHovered = true; }, { passive: true });
      sectionEl.addEventListener('touchend', () => { 
        setTimeout(() => { isHovered = false; }, 2000); 
      }, { passive: true });
    }

    // ── Intersection reveal ──
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      sectionEl.querySelectorAll('.wy-reveal').forEach(el => obs.observe(el));
    }

    // ── Quick add to cart ──
    sectionEl.querySelectorAll('.wy-card__atc[data-variant-id]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        const prev = btn.innerHTML;
        btn.innerHTML = '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        } catch(_) {}
        setTimeout(() => { btn.disabled = false; btn.innerHTML = prev; }, 1800);
      });
    });
  }

  document.querySelectorAll('[id^="wy-featured-"]').forEach(initFeatured);

  // Hot-reload in Shopify editor
  document.addEventListener('shopify:section:load', e => {
    const s = e.target.querySelector('[id^="wy-featured-"]');
    if (s) initFeatured(s);
  });

  // Handle section unload/removal
  document.addEventListener('shopify:section:unload', e => {
    const s = e.target.querySelector('[id^="wy-featured-"]');
    if (s) {
      const id = s.id.replace('wy-featured-', '');
      if (window.wyFeaturedAutoplayIntervals && window.wyFeaturedAutoplayIntervals[id]) {
        clearInterval(window.wyFeaturedAutoplayIntervals[id]);
        delete window.wyFeaturedAutoplayIntervals[id];
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wy-product-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initGrid(sectionEl) {
    // Intersection reveal
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.07, rootMargin: '0px 0px -40px 0px' });
      sectionEl.querySelectorAll('.wy-reveal').forEach(el => obs.observe(el));
    }

    // Quick add
    sectionEl.querySelectorAll('.wy-card__atc[data-variant-id]').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        const prev = btn.innerHTML;
        btn.innerHTML = '<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (res.ok) document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch(_) {}
        setTimeout(() => { btn.disabled = false; btn.innerHTML = prev; }, 1800);
      });
    });
  }

  document.querySelectorAll('[id^="wy-grid-"]').forEach(initGrid);

  document.addEventListener('shopify:section:load', e => {
    const s = e.target.querySelector('[id^="wy-grid-"]');
    if (s) initGrid(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
